import { getInternalAppType } from 'integrations-lib/constants/AppIds';
export const isInternalApp = appId => {
  return !!appId && getInternalAppType(appId) !== undefined;
};
export const shouldHideAppStatuses = appId => {
  return isInternalApp(appId) || !appId;
};